import { render, staticRenderFns } from "./ViewTabs.vue?vue&type=template&id=52598469&scoped=true"
import script from "./ViewTabs.vue?vue&type=script&lang=ts"
export * from "./ViewTabs.vue?vue&type=script&lang=ts"
import style0 from "./ViewTabs.scss?vue&type=style&index=0&id=52598469&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52598469",
  null
  
)

export default component.exports